/**
 * AirportModule — admin OS surface for the /airport pillar.
 *
 * Lounges, dining, meet-and-greet, fast-track, chauffeur services.
 */
import React from "react";
import Placeholder from "@/pages/admin/os/Placeholder";

export default function AirportModule() {
  return (
    <Placeholder
      title="Airport · Admin"
      phase="Phase 2"
      testid="os-modules-airport"
      description="Airport experiences the Concierge® arranges · lounges, dining, meet-and-greet, fast-track, chauffeur. Brief queue lives in Operate → Requests."
      willInclude={[
        "Lounge access rules per partner (Plaza Premium, Priority Pass)",
        "Meet-and-greet provider roster per airport",
        "Viator product overrides (founder-vetted alternatives)",
        "Airport brief queue & confirmation pipeline",
      ]}
    />
  );
}
